import { createFileRoute, redirect } from '@tanstack/react-router'
import Loader from '@/components/common/Loader'
import { lazy, Suspense } from 'react'

const PermitTemplateFormPage = lazy(async () => {
  const module = await import(
    '@/features/city-clerk/permit-template/pages/NewPermitTemplateFormPage/NewPermitTemplateFormPage'
  )
  return { default: module.default }
})

export const Route = createFileRoute(
  '/(app)/city-clerk/$id/permit-template/$templateId',
)({
  validateSearch: (search: Record<string, unknown>) => ({
    mode: (search.mode === 'add-version' ? 'add-version' : 'edit') as
      | 'edit'
      | 'add-version',
  }),
  beforeLoad: ({ context }) => {
    if (context.auth.loading) return
    if (!context.auth.userInfo?.uiCapabilities?.permitTemplatesView) {
      throw redirect({ to: '/access-denied' })
    }
  },
  component: PermitTemplateDetailsPage,
})

function PermitTemplateDetailsPage() {
  const { templateId } = Route.useParams()
  const { mode } = Route.useSearch()
  return (
    <Suspense
      fallback={
        <div className="h-page bg-(--color-surface) flex items-center justify-center z-9999">
          <Loader size="lg" />
        </div>
      }
    >
      <PermitTemplateFormPage mode={mode} templateId={templateId} />
    </Suspense>
  )
}
